<template>
  <div class="main-sidebar">
    <section class="sidebar">
      <ul class="sidebar-menu" data-widget="tree">
        <li class="header">导航</li>
        <template v-for="(page, a) in navigation">
          <li :class="url === page.url ? 'active' : ''">
            <router-link :to="page.url">
              <i :class="'fa ' + page.icon"></i>
              <span>{{ page.name }}</span>
            </router-link>
          </li>
        </template>
      </ul>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  computed: mapState({
    config: (state) => state.config,
    navigation: (state) => state.navigation,
    url: (state) => state.page,
  }),
}
</script>
